import React, {useState} from "react";
import './ToggleSwitchButton.css';

const ToggleSwitchButton=({title, isToggled, id, additionalStyle, disable,optionalTitle, setIsToggled, taggleFun })=>{

  return(
  <>
  <div className={`custom-switch ${isToggled ? 'on' : 'off'}`} onClick={() => {setIsToggled(!isToggled); taggleFun(!isToggled)}}>
    <div className="switch-knob" />
  </div>
  </>
  );
}
export default ToggleSwitchButton;
